/**
 * Shared wizard shell — step indicator + title + body slot + footer
 * with back/next buttons.
 *
 * Stateless presentational component. Receives all state via props.
 * Step components render INSIDE ``children``.
 */
import React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "../../../components/ui/button";

export default function WizardStepContainer({
  title,
  currentStep,
  totalSteps,
  children,
  onBack,
  onNext,
  nextLabel = "Weiter",
  nextDisabled = false,
  nextLoading = false,
}) {
  return (
    <div className="rounded-[14px] border border-black/10 bg-white p-6 dark:border-white/[0.07] dark:bg-[#141824]">
      <div className="mb-4 flex items-baseline gap-3">
        <span className="text-[11px] font-bold uppercase tracking-[1px] text-[#64748b] dark:text-[#6b7a9a]">
          Schritt {currentStep} / {totalSteps}
        </span>
      </div>
      <h2 className="mb-6 text-[20px] font-bold text-[#0f172a] dark:text-[#eef2ff]">
        {title}
      </h2>

      <div className="mb-6">{children}</div>

      <div className="flex items-center justify-between gap-3 border-t border-black/10 pt-4 dark:border-white/[0.07]">
        <div>
          {onBack ? (
            <Button
              type="button"
              variant="outline"
              onClick={onBack}
              disabled={nextLoading}
            >
              Zurück
            </Button>
          ) : null}
        </div>
        <Button
          type="button"
          onClick={onNext}
          disabled={nextDisabled || nextLoading}
        >
          {nextLoading ? (
            <>
              <Loader2 className="animate-spin" />
              Wird gesendet…
            </>
          ) : (
            nextLabel
          )}
        </Button>
      </div>
    </div>
  );
}
